import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_vendor_lots_for_dnspService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { material_ids?: number[], do_not_ship_date?: string, do_not_ship_status_id?: number }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, MaterialId?: number, Lots?: { Id?: number, LookupCode?: string, StatusId?: number, LicensePlateContents?: { LicensePlateId?: number, LotId?: number, LicensePlate?: { Id?: number, LookupCode?: string, StatusId?: number } }[] }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { material_ids?: number[], do_not_ship_date?: string, do_not_ship_status_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, MaterialId?: number, Lots?: { Id?: number, LookupCode?: string, StatusId?: number, LicensePlateContents?: { LicensePlateId?: number, LotId?: number, LicensePlate?: { Id?: number, LookupCode?: string, StatusId?: number } }[] }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { material_ids?: number[], do_not_ship_date?: string, do_not_ship_status_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, MaterialId?: number, Lots?: { Id?: number, LookupCode?: string, StatusId?: number, LicensePlateContents?: { LicensePlateId?: number, LotId?: number, LicensePlate?: { Id?: number, LookupCode?: string, StatusId?: number } }[] }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      material_ids?: number[], do_not_ship_date?: string, do_not_ship_status_id?: number    }) {
      return false;
    }
}
